"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashCode128 = exports.hashCode32 = void 0;

var _toTypeString = require("./to-type-string");

var _is = require("./is");

var _murmurhash3js = _interopRequireDefault(require("murmurhash3js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const hashCode32 = source => {
  const sourceString = convertToString(source);
  return _murmurhash3js.default.x86.hash32(sourceString);
  /* Too many collisions:
  const iterator = sourceString[Symbol.iterator]()
   const reducer = (acc, char) => {
    // tslint:disable-next-line:no-bitwise
    return (Math.imul(31, acc) + char.charCodeAt(0)) | 0
  }
   const hash = reduceIterator(reducer, 0, iterator)
   return Math.abs(hash)
  */
};

exports.hashCode32 = hashCode32;

const hashCode128 = source => {
  const sourceString = convertToString(source);
  return _murmurhash3js.default.x86.hash128(sourceString);
};

exports.hashCode128 = hashCode128;

const isTrackable = source => typeof source === 'object' && source !== null;

const convertToString = (source, refs = new WeakSet()) => {
  if (isTrackable(source)) {
    if (refs.has(source)) {
      return '';
    }

    refs.add(source);
  }

  if (typeof source === 'object' && source !== null) {
    if ((0, _is.isMap)(source)) {
      return Array.from(source.entries()).reduce((acc, [key, value]) => acc + key + convertToString(value, refs), 'Map::');
    } else if ((0, _is.isSet)(source)) {
      return Array.from(source).reduce((acc, value) => acc + convertToString(value, refs), 'Set::');
    } else if ((0, _is.isArray)(source)) {
      return source.reduce((acc, value) => acc + convertToString(value, refs), 'Array::');
    } else if (source.toString === Object.prototype.toString) {
      return Object.entries(source).reduce((acc, [key, value]) => {
        return acc + key + convertToString(value, refs);
      }, 'Object::');
    }
  } else if ((0, _is.isFunction)(source)) {
    return 'Function::' + source.toString();
  }

  return (0, _toTypeString.toTypeString)(source);
};